export const shouldAllowThisRedirect = (url?: string | null): boolean => {
  if (url && /^\/spa\/\w+\/login/i.test(url)) {
    return false;
  }
  if (url?.startsWith('/spa')) {
    return true;
  }
  return false;
};
